import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app.jsx';
import '../styles.css';
import '../styles-stad.css';
import '../rotterdam-luxe.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
    this._onNav = () => { if (this.state.err) this.setState({ err: null }); };
  }
  componentDidMount() { window.addEventListener('popstate', this._onNav); }
  componentWillUnmount() { window.removeEventListener('popstate', this._onNav); }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) {
    console.error('[ErrorBoundary]', err?.message, '\n', err?.stack, '\n', info?.componentStack);
  }
  render() {
    if (this.state.err) {
      return (
        <pre style={{ padding: '2rem', whiteSpace: 'pre-wrap', fontFamily: 'monospace', background: '#fee', color: '#900' }}>
          {String(this.state.err?.message)}{'\n\n'}{String(this.state.err?.stack)}
        </pre>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
